import { User } from '@app/models/user';
import { Action } from '@ngrx/store';

export enum UserActionTypes {
    Load = '[User] Load',
    LoadSuccess = '[User] Load Success',
    LoadFail = '[User] Load Fail',
    LoadSelf = '[APISelf] Load self',
    LoadSelfSuccess = '[APISelf] Load self Success',
    LoadSelfFail = '[APISelf] Load self Fail',

    Create = '[API] Create user',
    CreateSuccess = '[API] Create user success',
    CreateFail = '[API] Create user fail',

    AddOne = '[User] Add one',
    AddAll = '[User] Add all',

    Update = '[User] Update user',
    UpdateSuccess = '[User] Update user success',
    UpdateFail = '[User] Update user fail',
    UpdateOne = '[User] Update one',

    UpdateBusiness = "[UserBusiness] Update user business",
    UpdateBusinessSuccess = "[UserBusiness] Update user business success",
    UpdateBusinessFail = "[UserBusiness] Update user business fail",
    
    ExportUser = '[User] Export user',
    ExportUserSuccess = '[User] Export user success',
    ExportUserFail = '[User] Export user fail',
    
    FetchUsersByType = '[User] Fetch users by type',
    FetchUsersByTypeSuccess = '[User] Fetch users by type success',
    FetchUsersByTypeFail = '[User] Fetch users by type fail'
}

export class Load implements Action {
    readonly type = UserActionTypes.Load;
    constructor() {}
}

export class LoadSuccess implements Action {
    readonly type = UserActionTypes.LoadSuccess;
    constructor(public users: User[]) {}
}

export class LoadFail implements Action {
    readonly type = UserActionTypes.LoadFail;
    constructor(public error: any) {}
}

export class LoadSelf implements Action {
    readonly type = UserActionTypes.LoadSelf;
    constructor() {}
}

export class LoadSelfSuccess implements Action {
    readonly type = UserActionTypes.LoadSelfSuccess;
    constructor(public user: User) {}
}

export class LoadSelfFail implements Action {
    readonly type = UserActionTypes.LoadSelfFail;
    constructor(public error: any) {}
}

export class Create implements Action {
    readonly type = UserActionTypes.Create;
    constructor(public user: User) {}
}

export class CreateSuccess implements Action {
    readonly type = UserActionTypes.CreateSuccess;
    constructor(public user: User) {}
}

export class CreateFail implements Action {
    readonly type = UserActionTypes.CreateFail;
    constructor(public error: any) {}
}

export class AddOne implements Action {
    readonly type = UserActionTypes.AddOne;
    constructor(public user: User) {}
}

export class AddAll implements Action {
    readonly type = UserActionTypes.AddAll;
    constructor(public users: User[]) {}
}

export class Update implements Action {
    readonly type = UserActionTypes.Update;
    constructor(public id: number, public user: any) {}
}
export class UpdateFail implements Action {
    readonly type = UserActionTypes.UpdateFail;
    constructor(public error: any) {}
}

export class UpdateSuccess implements Action {
    readonly type = UserActionTypes.UpdateSuccess;
    constructor(public id: number, public data: any) {}
}

export class UpdateOne implements Action {
    readonly type = UserActionTypes.UpdateOne;
    constructor(public user: User) {}
}

export class ExportUser implements Action {
    readonly type = UserActionTypes.ExportUser;
    constructor(public data: any) {}
}

export class ExportUserSuccess implements Action {
    readonly type = UserActionTypes.ExportUserSuccess;
    constructor() {}
}

export class ExportUserFail implements Action {
    readonly type = UserActionTypes.ExportUserFail;
    constructor() {}
}

export class UpdateBusiness implements Action {
    readonly type = UserActionTypes.UpdateBusiness;
    constructor(public id: number, public data: any) {}
}
export class UpdateBusinessFail implements Action {
    readonly type = UserActionTypes.UpdateBusinessFail;
    constructor(public error: any) {}
}

export class UpdateBusinessSuccess implements Action {
    readonly type = UserActionTypes.UpdateBusinessSuccess;
    constructor(public id: number, public data: any) {}
}

export class FetchUsersByType implements Action {
    readonly type = UserActionTypes.FetchUsersByType;
    constructor(public typeUser: string) {}
}
export class FetchUsersByTypeFail implements Action {
    readonly type = UserActionTypes.FetchUsersByTypeFail;
    constructor(public error: any) {}
}

export class FetchUsersByTypeSuccess implements Action {
    readonly type = UserActionTypes.FetchUsersByTypeSuccess;
    constructor(public data: any) {}
}
export type UserActionsUnion =
    | Load
    | LoadSuccess
    | LoadFail
    | LoadSelf
    | LoadSelfSuccess
    | LoadSelfFail
    | Create
    | CreateSuccess
    | CreateFail
    | AddOne
    | AddAll
    | Update
    | UpdateFail
    | UpdateSuccess
    | UpdateOne
    | UpdateBusiness
    | UpdateBusinessSuccess
    | UpdateBusinessFail
    | ExportUser
    | ExportUserSuccess
    | ExportUserFail
    | FetchUsersByType
    | FetchUsersByTypeFail
    | FetchUsersByTypeSuccess;
